import { render, staticRenderFns } from "./dialog-admin-edit-message.vue?vue&type=template&id=0b2832d0&scoped=true&"
import script from "./dialog-admin-edit-message.vue?vue&type=script&lang=js&"
export * from "./dialog-admin-edit-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2832d0",
  null
  
)

export default component.exports